import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { UserService } from "@/services";

const Level = () =>
  import(
    /* webpackChunkName: "AccountLevel" */ "@/components/AccountPage/Level/index"
  );
const Personal = () =>
  import(
    /* webpackChunkName: "AccountPersonal" */ "@/components/AccountPage/Personal/index"
  );
const Banking = () =>
  import(
    /* webpackChunkName: "AccountBanking" */ "@/components/AccountPage/Banking/index"
  );
const Security = () =>
  import(
    /* webpackChunkName: "AccountSecurity" */ "@/components/AccountPage/Security/index"
  );
const Setting = () =>
  import(
    /* webpackChunkName: "AccountSecurity" */ "@/components/AccountPage/Setting/index"
  );

export default {
  name: "account-page",
  components: { Personal, Banking, Security, Level, Setting },
  props: [],
  data() {
    return {
      isLegal: this.$cookies.get("CA_ID")
    };
  },
  computed: {
    ...mapGetters({
      getSelectedTab: types.account.getters.SELECTED_TAB
    }),
    tabs() {
      return [
        {
          title: this.$t("accountPage.level.title"),
          component: "level",
          route: "/account/level",
          isShow: !this.isLegal
        },
        {
          title: this.$t("accountPage.identityInformation.title"),
          component: "personal",
          route: "/account/personal",
          isShow: !this.isLegal
        },
        {
          title: this.$t("accountPage.bankInformation.title"),
          component: "banking",
          route: "/account/banking",
          isShow: true
        },
        {
          title: this.$t("accountPage.identityInformation.title"),
          component: "security",
          isShow: this.isLegal,
          route: "/account/company-information"
        },
        {
          title: this.$t("accountPage.security.title"),
          component: "security",
          isShow: !this.isLegal,
          route: "/account/security"
        },
        {
          title: this.$t("accountPage.setting.title"),
          component: "setting",
          isShow: true,
          route: "/account/setting"
        }
      ];
    },
    selectedTab: {
      get() {
        return this.getSelectedTab;
      },
      set(val) {
        this.setTab(val);
        // switch (val) {
        //   case 0:
        //     if (this.$route.query.tab !== this.tabs[0].component) {
        //       this.$router.push({
        //         path: "account/personal",
        //       });
        //     }
        //     break;
        //   case 1:
        //     if (this.$route.query.tab !== this.tabs[1].component) {
        //       this.$router.push({
        //         path: "account/banking",
        //       });
        //     }
        //     break;
        //   case 2:
        //     if (this.$route.query.tab !== this.tabs[2].component) {
        //       this.$router.push({
        //         path: "account/security",
        //       });
        //     }
        //     break;
        // }
      }
    }
  },
  // created() {
  //   const isCompany = false;
  //   if (isCompany) {
  //     this.tabs.push({
  //       title: this.$t("accountPage.identityInformation.title"),
  //       component: "personal",
  //       route: "/account/personal",
  //       isShow: true
  //     });
  //   } else {
  //     this.tabs.push({
  //       title: this.$t("accountPage.identityInformation.title"),
  //       component: "personal",
  //       route: "/account/company-information",
  //       isShow: true
  //     });
  //   }
  // },
  mounted() {
    // this.tabQuery(this.$route.query.tab);
    this.getAuthVerifyInfo();
    this.getUserInfo();
  },
  methods: {
    ...mapActions({
      setTab: types.account.actions.SET_TAB,
      setUserData: types.userInfo.actions.ACTION_USER_INFO,
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO
    }),
    getAuthVerifyInfo() {
      UserService.getVerifyInfo().then(response => {
        this.setVerifyData(response.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    }
    // tabQuery(tab) {
    //   if (tab) {
    //     switch (tab) {
    //       case "personal":
    //         if (this.selectedTab !== 0) {
    //           this.selectedTab = 0;
    //         }
    //         break;
    //       case "banking":
    //         if (this.selectedTab !== 1) {
    //           this.selectedTab = 1;
    //         }
    //         break;
    //       case "security":
    //         if (this.selectedTab !== 2) {
    //           this.selectedTab = 2;
    //         }
    //         break;
    //     }
    //   }
    // },
  },
  watch: {
    // $route(route) {
    //   const {
    //     query: { tab },
    //   } = route;
    //   switch (tab) {
    //     case "personal":
    //       if (this.selectedTab !== 0) {
    //         this.selectedTab = 0;
    //       }
    //       break;
    //     case "banking":
    //       if (this.selectedTab !== 1) {
    //         this.selectedTab = 1;
    //       }
    //       break;
    //     case "security":
    //       if (this.selectedTab !== 2) {
    //         this.selectedTab = 2;
    //       }
    //       break;
    //   }
    // },
  }
};
